import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { RawHtml } from "ui/raw-html";

class Notification extends React.Component {
  static get displayName() {
    return "Notification";
  }

  static get propTypes() {
    return {
      success: PropTypes.node,
      successChildren: PropTypes.node,
      error: PropTypes.node,
      errorChildren: PropTypes.node,
      warning: PropTypes.node,
      warningChildren: PropTypes.node,
    };
  }

  render() {
    return (
      <div>
        <Alert
          type="danger"
          message={this.props.error}
          visible={Boolean(this.props.error)}
        >
          {this.props.errorChildren}
        </Alert>
        <Alert
          type="success"
          message={this.props.success}
          visible={Boolean(this.props.success)}
        >
          {this.props.successChildren}
        </Alert>
        <Alert
          type="warning"
          message={this.props.warning}
          visible={Boolean(this.props.warning)}
        >
          {this.props.warningChildren}
        </Alert>
      </div>
    );
  }
}

class Alert extends React.Component {
  static get displayName() {
    return "Alert";
  }

  static get propTypes() {
    return {
      visible: PropTypes.bool.isRequired,
      message: PropTypes.node,
      type: PropTypes.oneOf(["danger", "warning", "success"]),
      children: PropTypes.node,
    };
  }

  render() {
    const { message } = this.props;
    let classes = {
      alert: true,
      "alert-box": true,
      hidden: !this.props.visible,
    };

    classes[`alert-${this.props.type}`] = true;
    classes = classNames(classes);

    return (
      <div className={classes}>
        {typeof message === "string" ? <RawHtml html={message} /> : message}
        {this.props.children}
      </div>
    );
  }
}

export default Notification;
export { Notification };
